import moment from 'moment-timezone';

export class EnterpriseDataCompleteness {
	key: string;
	originContractId: string;
	serviceTypeId: string;
	dbaName: string;
	locationAddress1: string;
	locationAddress2: string;
	locationCity: string;
	locationZipCode: string;
	dataCompleteness: {
		date: Date;
		dataCompletenessStatus: number;
		dataCompletenessStatusName: string;
		hasMissingLocationBills?: boolean;
		hasIncompleteBillFields?: boolean;
	}[];

	constructor(entepriseDataCompleteness?: EnterpriseDataCompleteness) {
		Object.assign(this, entepriseDataCompleteness);

		this.dataCompleteness = this.dataCompleteness
			? this.dataCompleteness.map(d => ({ ...d, date: new Date(moment(d.date).format('MMM DD, YYYY 00:00:00 a')) }))
			: [];
	}
}
